// extracted by mini-css-extract-plugin
export var dropdown = "component-dropdown-module--dropdown--301b7";
export var open = "component-dropdown-module--open--9ef72";
export var qus = "component-dropdown-module--qus--56c43";
export var subtitle = "component-dropdown-module--subtitle--b466f";